// extracted by mini-css-extract-plugin
export default {"tags":"tags_tags__fnv2p","tag":"tags_tag__ZIah8","rotate":"tags_rotate__HSOm3"};